import apiClient from "../common/apiClient";

async function getNoAuthSpecific() {

    let path = "";

    for ( let arg of arguments ) {

        path += "/" + arg;
        
    }

    let response = await apiClient.get(`/noAuth${path}`);

    return response.data;

}

export default getNoAuthSpecific;